/* eslint-disable no-underscore-dangle */
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './style';
import { ReactComponent as M5 } from '../../../../Asset/svg/matching5.svg';
import { useHistory } from 'react-router-dom';
import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import { useMemo } from 'react';

interface IMatching {
  data: any;
  linkEbook?: string;
  linkResultTest?: string;
}

const MatchingEquilibre = (props: IMatching) => {
  const classes = useStyles();
  const history = useHistory();
  const { data, linkEbook, linkResultTest } = props;

  const equilibreVie = useMemo(() => {
    return data?._data?.conditionsCandidat || [];
  }, [data]);

  return (
    <div className={classes.containerMatch}>
      <Grid container={true} alignItems="center" justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <M5 style={{ width: 30, height: 33, marginRight: 15 }} />
          <Typography className={classes.matchTitle}>
            Matching <span>Équilibre de vie</span>
          </Typography>
        </Grid>
        <Grid item={true} lg="auto">
          {data?.isComplete && (
            <CircularProgressCustom
              value={Math.round(data?.totalPercent || 0)}
              color="#BC72A7"
              size={40}
              fontSize={12}
              fontSizeFloat={12}
              isPercent={true}
            />
          )}
        </Grid>
      </Grid>
      {/* 16 soft skills Harmony® */}
      <Grid
        style={{ marginTop: 20 }}
        container={true}
        alignItems="center"
        justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <Typography className={classes.titleTable}>Équilibre vie pro / perso</Typography>
        </Grid>
        <Grid item={true} lg="auto">
          <Button
            variant="contained"
            color="primary"
            className={classes.btnPrimarySeek}
            onClick={() => linkEbook && history.push(linkEbook as string)}>
            Accès ebook
          </Button>
        </Grid>
      </Grid>
      <Grid style={{ marginTop: 20 }} container={true} item={true}>
        {/* body */}
        <Grid
          item={true}
          lg={8}
          style={{
            borderTop: '1px solid #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
            borderTopLeftRadius: 5,
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Nombre de jour de télétravail par semaine
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderTop: '1px solid #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderTopRightRadius: 5,
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleMatch}>
              {equilibreVie?.teletravail?.value || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={8}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Nombre de jours de congés annuels, vous souhaiteriez dans l’idéal et au minimum
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleMatch}>
              {equilibreVie?.conges?.value || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={8}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Organisation hebdomadaire
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleMatch}>
              {equilibreVie?.organisation_hebdomadaire?.value || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={8}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
            borderBottomLeftRadius: 5,
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Temps de transport quotidien
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderBottomRightRadius: 5,
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleMatch}>
              {equilibreVie?.temps_transport?.value || 'NC'}
            </Typography>
          </div>
        </Grid>
      </Grid>
      {/* 16 soft skills Harmony® */}
    </div>
  );
};

export default MatchingEquilibre;
